import React from "react"

import Title from "../../../components/global/Title/Title"
import Content from "../../../components/global/Content/Content"
import Button from "../../../components/global/Button/Button"
import Animation from "../../../components/global/Animation/Animation"

export default class HeaderLarge extends React.Component {
  render() {
    const { acf } = this.props.data;

    return(
      <section className="relative p-0 dotted">
        <Animation/>

        <div className="max-w-screen-xxl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
          <div className="text-center w-full lg:w-1/2 mx-auto xs:pt-40 lg:pt-64 xs:pb-12 lg:pb-24">
            <Title level="1">{acf && acf.title_header}</Title>
            <div className="max-w-lg mx-auto">
              <Content>{acf && acf.content_header}</Content>
            </div>
            <div className="text-center mt-8">
              {acf && acf.buttons && acf.buttons.map(element => (
                <div key={element.link.title} className="mr-2 inline-block">
                  <Button link={element.link.url.replace('https://www.rt132.nl/', '')} type={element.type_button}>{element.link.title}</Button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
